import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserZooGame from 'src/games/ZooGame/Main';

interface ZooGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class ZooGame extends React.Component<ZooGameProps> {
    constructor(props: ZooGameProps) {
        super(props);
        bindAllOfThis(this, ZooGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserZooGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default ZooGame;



// WEBPACK FOOTER //
// ./src/pages/game/ZooGame.tsx